export default (sidebarData) => ({
  address: {
    street_1: sidebarData.street_1,
    street_2: sidebarData.street_2 || '',
    city: sidebarData.city,
    state: sidebarData.state,
    zip: sidebarData.zip,
    country: sidebarData.country || 'US',
  },
});
